import mdlData from './mdl-valence-model';

function coreString(element, charge) {
  if (charge === 0) {
    return element;
  }
  return element + (charge > 0 ? '+' : '-') + Math.abs(charge);
}

class ValenceModel {
  constructor(data) {
    this.possibleValences = {};
    this.knownCharges = {};
    for (const entry of data) {
      const [core, valences] = entry;
      valences.sort((a, b) => a > b);
      this.possibleValences[coreString(core.element, core.charge)] = valences;
      if (this.knownCharges[core.element] === undefined) {
        this.knownCharges[core.element] = [];
      }
      this.knownCharges[core.element].push(core.charge);
    }
    for (const charges of Object.values(this.knownCharges)) {
      charges.sort((a, b) => a > b);
    }
  }

  valence(element, charge, explicitValence) {
    // smallest valence equal or bigger than explicitValence valence
    const key = coreString(element, charge);
    const options = this.possibleValences[key];
    if (options == null) {
      return explicitValence;
    }

    for (const option of options) {
      if (option >= explicitValence) {
        // options are sorted, so it's the smallest one satisfying the condition
        return option;
      }
    }
    return null;
  }
}

export const mdlModel = new ValenceModel(mdlData);
